/**
 * @input 'attachment; filename="_ _.xml"; filename*=UTF-8\'\'%D7%A9%D7%A2%D7%A8.xml'
 * @output 'שער.xml'
 */
export function parseContentDispositionFilename(headerValue) {
  if (!headerValue) return null;

  const encodedMatch = headerValue.match(/filename\*=UTF-8''([^;]+)/i);
  if (encodedMatch) {
    try {
      return decodeURIComponent(encodedMatch[1]);
    } catch {
      return null;
    }
  }

  const plainMatch = headerValue.match(/filename="?([^";]+)"?/i);
  if (!plainMatch) return null;

  return plainMatch[1];
}

/**
 * @input {response: Response, fallbackName: 'export.xml'}
 * @output undefined
 */
export async function saveResponseAsFile({ response, fallbackName }) {
  const blob = await response.blob();
  const filename =
    parseContentDispositionFilename(
      response.headers.get("Content-Disposition"),
    ) || fallbackName;

  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = objectUrl;
  if (filename) link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
}
